import { Flex, Image, Text, useDisclosure, Box } from '@chakra-ui/react'
import { Button, Column, Row, TextInput } from '@ubirider/pick-component-library'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { useEffect, useState } from 'react'

import AcquaViasLogo from '../../assets/logo.svg'
import VehicleIcon from '../../assets/car.svg'
import SearchIcon from '../../assets/magnifying_glass.svg'
import { getUnpaidTripsByLicensePlate } from '../../api/user'
import { LicensePlateUnpaidTripsModal } from '../../modals/LicensePlateUnpaidTripsModal'

export default function Landing() {
  const { t } = useTranslation()

  const { onOpen } = useDisclosure()
  const { isOpen: isOpenLicensePlateCheck, onOpen: onOpenLicensePlateCheck, onClose: onCloseLicensePlateCheck } = useDisclosure()

  const [login, getLogin] = useState(false)
  const [licensePlate, setLicensePlate] = useState('')
  const [loading, setLoading] = useState(false)
  const [unpaidTrips, setUnpaidTrips] = useState([])

  useEffect(() => {
    onOpen()
  }, [])

  useEffect(() => {
    if (!isOpenLicensePlateCheck) setLicensePlate('')
  }, [isOpenLicensePlateCheck])

  const handleFetchUnpaidTrips = async () => {
    setLoading(true)
    try {
      const res = await getUnpaidTripsByLicensePlate(licensePlate)
      setUnpaidTrips(res || [])
      onOpenLicensePlateCheck()
    } catch (e) {
      console.error(e)
    }
    setLoading(false)
  }

  return (
    <Flex
      as='main'
      direction='column'
      minHeight='100vh'
      minWidth='100vw'
      bgGradient='linear(to-b, #BBF0FD 23.89%, #088AC6 100%)'
    >
      <Flex
        flex='1'
        direction={{ base: 'column', lg: 'row' }}
        padding={{ sm: '24px', lg: '72px' }}
        gap={{ base: '24px', lg: '80px' }}
        alignItems={{ base: 'center', lg: 'flex-start' }}
        justifyContent={{ sm: 'center', lg: 'flex-start' }}
      >
        {/* Left Side: Branding and Welcome */}
        <Flex
          direction='column'
          flex={{ base: 'none', lg: '6' }}
          display={login ? { base: 'none', lg: 'flex' } : 'flex'}
          justify='center'
          align={{ base: 'center', lg: 'flex-start' }}
          textAlign={{ base: 'center', lg: 'left' }}
          h='100%'
        >
          <Flex direction='column' mt={{ sm: '48px', lg: 0 }} gap={{ base: '24px', lg: '48px' }}>
            <Image src={AcquaViasLogo} w={{ base: '300px', md: '330px' }} mx={{ base: 'auto', lg: '0' }} />

            <Flex direction='column' gap='16px' padding={{ sm: '32px', lg: '0' }}>
              <Text
                fontSize={{ base: '28px', md: '36px', lg: '48px' }}
                maxW={{ base: '100%', lg: '517px' }}
                fontWeight='700'
                color='white'
              >
                {t('acqua_vias.intro_welcome_title')}
              </Text>
              <Text fontSize={{ base: '16px', lg: '24px' }} fontWeight='700' color='white'>
                {t('acqua_vias.intro_welcome_description')}
              </Text>
            </Flex>

            {/* Mobile Login Button */}
            {!login && (
              <Box w='100%' px='32px' display={{ lg: 'none' }}>
                <Button
                  onClick={() => getLogin(true)}
                  style='solid'
                  type='secondary'
                  label={t('common.login')}
                  css={{ width: '100%' }}
                />
              </Box>
            )}

            {/*<Box rounded='16px' border='1px solid #ffffff' padding='24px' w={{ lg: '645px'}}>
              <Column css={{ gap: 16 }}>
                <Text fontSize='20px' fontWeight='700' color='white'>
                  Tem viagens por pagar?
                </Text>
                <Text fontSize='14px' color='white'>
                  Rápido, seguro e transparente. Insira sua placa e regularize seus pagamentos pendentes em segundos.
                </Text>
                <Flex
                  direction={{ sm: 'column', lg: 'row'}}
                  padding='8px'
                  gap='10px'
                  bg='white'
                  rounded='16px'
                  border='1px solid #D0D5DD'
                >
                  <TextInput
                    placeholder={'LSN4I49'}
                    value={licensePlate}
                    onChange={e => setLicensePlate(e)}
                    leftIconSrc={VehicleIcon}
                    background='white'
                  />
                  <Button
                    onClick={handleFetchUnpaidTrips}
                    type='secondary'
                    style='outline'
                    loading={loading}
                    disabled={licensePlate === ''}
                    leftIconProps={{ src: SearchIcon }}
                    label='Pesquisar'
                  />
                </Flex>
              </Column>
            </Box>*/}
          </Flex>
        </Flex>

        {/* Right Side / Login Card */}
        <Flex
          display={login ? 'flex' : { base: 'none', lg: 'flex' }}
          width={{ base: '100%', md: '400px' }}
          height={{ sm: '90vh' }}
          maxHeight={{ base: 'auto', lg: 'calc(100vh - 160px)' }}
          overflowY='auto'
          backgroundColor='white'
          borderRadius='8px'
          alignSelf='center'
          direction='column'
        >
          <Outlet />
        </Flex>
      </Flex>

      <LicensePlateUnpaidTripsModal
        isOpen={isOpenLicensePlateCheck}
        onOpen={onOpenLicensePlateCheck}
        onClose={onCloseLicensePlateCheck}
        trips={unpaidTrips}
        licensePlate={licensePlate}
      />
    </Flex>
  )
}
